import { render, staticRenderFns } from "./compList.vue?vue&type=template&id=3774540a&scoped=true&"
import script from "./compList.vue?vue&type=script&lang=js&"
export * from "./compList.vue?vue&type=script&lang=js&"
import style0 from "./compList.vue?vue&type=style&index=0&id=3774540a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3774540a",
  null
  
)

export default component.exports